import axios from 'axios';

// API Configuration — use hostname detection (more reliable than NODE_ENV with Parcel)
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE_URL = isLocal
  ? 'http://localhost:5000'
  : window.location.origin;

// Configure axios defaults for cookie-based auth
axios.defaults.withCredentials = true;

// CSRF token helper — reads from cookie and sets header
const getCsrfToken = () => {
  const match = document.cookie.match(/csrf_token=([^;]+)/);
  return match ? match[1] : null;
};

// Add CSRF token to all state-changing requests
axios.interceptors.request.use((config) => {
  if (['post', 'put', 'delete', 'patch'].includes(config.method)) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
  }
  return config;
});

export { API_BASE_URL };
